(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector("[data-back-to-top]");
    if (!btn) return;
    btn.hidden = false;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var threshold = 600;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      btn.classList.toggle("is-visible", y > threshold);
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coverflow"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__neCoverflowInit) return;
    window.__neCoverflowInit = true;
    if (/firefox/i.test(navigator.userAgent)) { document.documentElement.classList.add('ne-ff'); }
    function initCoverflows(root) {
      (root || document).querySelectorAll('.ne-cf[data-coverflow]').forEach(function (cf) {
        if (cf.__neCf) return;
        cf.__neCf = true;
        var cards = Array.prototype.slice.call(cf.querySelectorAll('[data-cf-card]'));
        if (!cards.length) return;
        var n = cards.length;
        var loop = cf.getAttribute('data-cf-loop') === '1';
        var isDrum = cf.classList.contains('ne-cf--style-drum');
        var mqMobile = window.matchMedia('(max-width: 749px)');
        var active = 0;
        var cfW = 0; // cached block width for analytic focus migration
        // No-loop focus migration (desktop stack/fan only): the focus card glides
        // from left-of-centre (first card) → centre (middle cards) → right-of-centre
        // (last cards), so the lopsided one-sided pile always fills the block and the
        // focus never sticks at the edge. Loop is symmetric → centred → skipped.
        function focusShift() {
          if (loop || isDrum || mqMobile.matches || !cfW || n < 2) return null;
          var t = active / (n - 1);
          return ((t - 0.5) * 0.42 * cfW).toFixed(0) + 'px';
        }
        function measure() {
          var maxH = 0;
          cards.forEach(function (c) { var h = c.offsetHeight; if (h > maxH) maxH = h; });
          if (maxH) cf.style.setProperty('--ne-cf-h', maxH + 'px');
        }
        function bbox() {
          var minX = Infinity, maxX = -Infinity, any = false;
          cards.forEach(function (c) {
            if (c.hasAttribute('data-hidden')) return;
            var r = c.getBoundingClientRect();
            if (r.width) { any = true; if (r.left < minX) minX = r.left; if (r.right > maxX) maxX = r.right; }
          });
          return any ? { min: minX, max: maxX } : null;
        }
        function recenterDrum() {
          cf.classList.add('ne-cf--no-trans');
          cf.style.setProperty('--ne-cf-drum-shift', '0px');
          cf.style.setProperty('--ne-cf-drum-fit', '1');
          cf.style.setProperty('--ne-cf-ring-shift', '0px');
          void cf.offsetWidth;
          var sr = cf.getBoundingClientRect();
          cfW = sr.width;
          var b = bbox();
          var isMob = mqMobile.matches;
          if (b) {
            var fit;
            if (isMob) {
              fit = isDrum ? 1 : ((b.max - b.min) > sr.width * 1.6 ? (sr.width * 1.6 / (b.max - b.min)) : 1);
            } else {
              var avail = sr.width * 0.96;
              fit = (b.max - b.min) > avail ? (avail / (b.max - b.min)) : 1;
            }
            cf.style.setProperty('--ne-cf-drum-fit', fit.toFixed(3));
            void cf.offsetWidth;
            if (isMob) {
              var fc = cards[active] ? cards[active].getBoundingClientRect() : null;
              if (fc) cf.style.setProperty('--ne-cf-drum-shift', ((sr.left + sr.width / 2) - (fc.left + fc.right) / 2).toFixed(0) + 'px');
              if (isDrum) {
                void cf.offsetWidth;
                var rmin = Infinity, rmax = -Infinity;
                cards.forEach(function (c, i) {
                  if (i === active || c.hasAttribute('data-hidden')) return;
                  var cr = c.getBoundingClientRect();
                  if (cr.width) { if (cr.left < rmin) rmin = cr.left; if (cr.right > rmax) rmax = cr.right; }
                });
                if (rmin < Infinity) {
                  var ringNudge = sr.width * 0;
                  cf.style.setProperty('--ne-cf-ring-shift', (((sr.left + sr.width / 2) - (rmin + rmax) / 2) + ringNudge).toFixed(0) + 'px');
                }
              }
            } else if (!loop && !isDrum) {
              // No loop, stack/fan: migrate the focus card instead of centring the (lopsided) bbox.
              cf.style.setProperty('--ne-cf-drum-shift', focusShift() || '0px');
            } else {
              var b2 = bbox();
              if (b2) {
                // Centre the whole composition (focus card + ring) in the block.
                var sh2 = (sr.left + sr.width / 2) - (b2.min + b2.max) / 2;
                cf.style.setProperty('--ne-cf-drum-shift', sh2.toFixed(0) + 'px');
              }
            }
          }
          void cf.offsetWidth;
          cf.classList.remove('ne-cf--no-trans');
          if (isDrum && !mqMobile.matches) {
            var b3 = bbox();
            var pa = cf.querySelector('[data-cf-prev]'), na = cf.querySelector('[data-cf-next]');
            var fr = cards[active] ? cards[active].getBoundingClientRect() : null;
            var ringLeft = Infinity;
            cards.forEach(function (c, i) {
              if (i === active || c.hasAttribute('data-hidden')) return;
              var cr = c.getBoundingClientRect();
              if (cr.width && cr.left < ringLeft) ringLeft = cr.left;
            });
            if (fr) {
              var cy = (fr.top + fr.bottom) / 2 - sr.top;
              if (pa) pa.style.top = cy + 'px';
              if (na) na.style.top = cy + 'px';
            }
            if (pa && ringLeft < Infinity) {
              pa.style.left = (ringLeft - sr.left - pa.offsetWidth * 0.5 + 2) + 'px';
            }
            if (b3 && na) na.style.right = Math.max(2, sr.right - b3.max - na.offsetWidth - 6) + 'px';
          } else if (isDrum) {
            var paM = cf.querySelector('[data-cf-prev]'), naM = cf.querySelector('[data-cf-next]');
            var rmn = Infinity, rmx = -Infinity, rcy = 0, rcn = 0;
            cards.forEach(function (c, i) {
              if (i === active || c.hasAttribute('data-hidden')) return;
              var cr = c.getBoundingClientRect();
              if (cr.width) { if (cr.left < rmn) rmn = cr.left; if (cr.right > rmx) rmx = cr.right; rcy += (cr.top + cr.bottom) / 2; rcn++; }
            });
            if (rcn && paM && naM) {
              var cyR = rcy / rcn - sr.top;
              paM.style.top = cyR + 'px'; naM.style.top = cyR + 'px';
              paM.style.right = ''; naM.style.left = '';
              paM.style.left = Math.max(2, rmn - sr.left - paM.offsetWidth - 4) + 'px';
              naM.style.right = Math.max(2, sr.right - rmx - naM.offsetWidth - 4) + 'px';
            }
          }
        }
        function render() {
          cards.forEach(function (card, idx) {
            var d = idx - active;
            if (loop) { if (d > n / 2) d -= n; else if (d < -n / 2) d += n; }
            var ad = Math.abs(d);
            // Drum index: loop wraps the ring full; no-loop runs forward-only so
            // the ring empties as you reach the last card (di = forward distance).
            var di = loop ? ((idx - active + n) % n) : d;
            var hidden;
            if (mqMobile.matches) { hidden = isDrum ? (loop ? di > 4 : (d < 0 || d > 4)) : (ad > 2); }
            else if (isDrum) { hidden = loop ? false : (d < 0); }
            else { hidden = ad > 6; }
            if (hidden) {
              card.setAttribute('data-hidden', '');
              card.removeAttribute('data-active');
              return;
            }
            card.removeAttribute('data-hidden');
            card.style.setProperty('--d', d);
            card.style.setProperty('--ad', ad);
            var cad = Math.pow(ad, 0.6);
            card.style.setProperty('--cad', cad.toFixed(3));
            card.style.setProperty('--cd', (d < 0 ? -cad : cad).toFixed(3));
            var gad = 2 * (1 - Math.pow(0.5, ad));
            card.style.setProperty('--gad', gad.toFixed(3));
            card.style.setProperty('--gd', (d < 0 ? -gad : gad).toFixed(3));
            card.style.setProperty('--di', di);
            card.style.setProperty('--din', (n > 1 ? di / (n - 1) : 0).toFixed(3));
            if (d === 0) { card.setAttribute('data-active', ''); }
            else { card.removeAttribute('data-active'); }
          });
          var fs = focusShift();
          if (fs !== null) cf.style.setProperty('--ne-cf-drum-shift', fs);
        }
        function go(t) {
          if (loop) { active = (t % n + n) % n; }
          else { active = Math.max(0, Math.min(n - 1, t)); }
          render();
        }
        var nextBtn = cf.querySelector('[data-cf-next]');
        var prevBtn = cf.querySelector('[data-cf-prev]');
        if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1); });
        if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1); });
        cards.forEach(function (card, idx) {
          card.addEventListener('click', function (e) {
            if (idx !== active) { e.preventDefault(); e.stopPropagation(); go(idx); }
          });
        });
        // ---- Paging gestures (coverflow_nav) -------------------------------
        var nav = cf.getAttribute('data-cf-nav') || 'arrows';
        // Mobile standard for every optic: swipe/drag + the always-present tap
        // chevrons. Hover-edge has no touch, scroll fights the page, arrows are
        // tap-only — so on phones drag is the one gesture that always feels right.
        if (mqMobile.matches) {
          nav = 'drag';
          cf.classList.add('ne-cf--nav-drag');
        }
        if (nav === 'hover-edge') {
          var hDir = 0, hProx = 0, hRaf = null, hLast = 0;
          var hLoop = function (t) {
            if (hDir === 0) { hRaf = null; return; }
            var interval;
            if (isDrum) { interval = 780 - hProx * (hDir < 0 ? 250 : 360); }
            else { interval = 720 - hProx * 540; }
            if (t - hLast >= interval) { go(active + hDir); hLast = t; }
            hRaf = requestAnimationFrame(hLoop);
          };
          var DZ_DEAD_END = 0.38, DZ_SPLIT = 0.59, DZ_FWD_END = 0.79;
          cf.addEventListener('pointermove', function (e) {
            if (e.pointerType === 'touch') { hDir = 0; return; }
            var r = cf.getBoundingClientRect();
            if (isDrum) {
              var xf = (e.clientX - r.left) / Math.max(1, r.width);
              if (xf < DZ_DEAD_END || xf > DZ_FWD_END) { hDir = 0; }
              else if (xf < DZ_SPLIT) { hDir = -1; hProx = Math.min(1, (DZ_SPLIT - xf) / Math.max(0.01, DZ_SPLIT - DZ_DEAD_END)); }
              else { hDir = 1; hProx = Math.min(1, (xf - DZ_SPLIT) / Math.max(0.01, DZ_FWD_END - DZ_SPLIT)); }
            } else {
              var x = (e.clientX - r.left) / r.width, z = 0.22;
              if (x < z) { hDir = -1; hProx = (z - x) / z; }
              else if (x > 1 - z) { hDir = 1; hProx = (x - (1 - z)) / z; }
              else { hDir = 0; }
            }
            if (hDir !== 0 && !hRaf) { hLast = 0; hRaf = requestAnimationFrame(hLoop); }
          });
          cf.addEventListener('pointerleave', function () { hDir = 0; });
        } else if (nav === 'drag') {
          var dDrag = false, dStartX = 0, dStartActive = 0, dSteps = 0, dMoved = 0, dStep = 60;
          cf.addEventListener('pointerdown', function (e) {
            if (e.target.closest && e.target.closest('[data-cf-prev],[data-cf-next]')) return;
            dDrag = true; dStartX = e.clientX; dStartActive = active; dSteps = 0; dMoved = 0;
            dStep = Math.max(54, cf.getBoundingClientRect().width * 0.11);
            try { cf.setPointerCapture(e.pointerId); } catch (err) {}
            cf.classList.add('ne-cf--grabbing');
          });
          cf.addEventListener('pointermove', function (e) {
            if (!dDrag) return;
            var dx = e.clientX - dStartX; dMoved = Math.abs(dx);
            var steps = Math.round(-dx / dStep);
            if (steps !== dSteps) { dSteps = steps; go(dStartActive + steps); }
          });
          var dEnd = function () { if (dDrag) { dDrag = false; cf.classList.remove('ne-cf--grabbing'); } };
          cf.addEventListener('pointerup', dEnd);
          cf.addEventListener('pointercancel', dEnd);
          cf.addEventListener('click', function (e) { if (dMoved > 6) { e.preventDefault(); e.stopPropagation(); dMoved = 0; } }, true);
          cf.addEventListener('dragstart', function (e) { e.preventDefault(); });
        } else if (nav === 'scroll') {
          var sAcc = 0, sLock = false;
          cf.addEventListener('wheel', function (e) {
            var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
            sAcc += d; e.preventDefault();
            if (sLock) return;
            if (Math.abs(sAcc) >= 48) {
              go(active + (sAcc > 0 ? 1 : -1)); sAcc = 0; sLock = true;
              setTimeout(function () { sLock = false; }, 200);
            }
          }, { passive: false });
        }
        measure();
        render();
        recenterDrum(); requestAnimationFrame(recenterDrum); setTimeout(recenterDrum, 450);
        cf.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', function () { measure(); recenterDrum(); }, { once: true });
        });
        requestAnimationFrame(measure);
        setTimeout(measure, 400);
        requestAnimationFrame(recenterDrum); setTimeout(recenterDrum, 500);
        window.addEventListener('resize', function () { measure(); render(); recenterDrum(); });
        if (window.ResizeObserver) { new ResizeObserver(measure).observe(cf); }
      });
    }
    // Exposed so AJAX-refetched grids (related / complementary) can re-init a
    // freshly-swapped .ne-cf element after the section replaces it.
    window.neInitCoverflows = initCoverflows;
    document.addEventListener('DOMContentLoaded', function () { initCoverflows(document); });
    document.addEventListener('shopify:section:load', function (e) { initCoverflows(e.target); });
    document.addEventListener('shopify:block:select', function (e) { initCoverflows(e.target.parentElement || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["floating-buttons"] && !Shopify.designMode) return;
  try {
    /* Stylesheet in den Shadow-Root von <shopify-chat> hängen.
     Warum überhaupt JS: der Shadow-Root ist offen, aber Dokument-CSS endet an
     seiner Grenze und die App bietet keine ::part()-Angriffsfläche. Die
     Theme-Variablen vererben hinein, das eingehängte CSS rechnet also mit
     denselben Werten wie der Rest der Seite. */
  (function () {
    var MARKE = 'data-ne-float-weld';

    /* Die Glasoptik ist 1:1 die von .ne-back-to-top--glass mit eingeschalteten
       Glas-Buttons (back-to-top.liquid). Bewusst dupliziert statt geteilt:
       Shadow-DOM kann keine Dokument-Regeln erben, nur Variablen. */
    /* ⚠️ DER KNOPF POSITIONIERT SICH SELBST (26.07, zweiter Anlauf).
       Zuerst hing die Position am Wrapper `.activator-nudge`. Nach einmal
       Öffnen und Schließen des Fensters stand der Knopf wieder ab Werk da:
       die App baut ihren Shadow-Inhalt dabei neu auf, und der Knopf hängt
       danach offenbar woanders. `position: fixed` am Knopf selbst ist von
       seiner Verschachtelung unabhängig — egal, in welchem Wrapper er landet.

       ⚠️ KLASSE DREIFACH (`button.activator.activator.activator`), aus
       demselben Grund wie beim Pandectes-Panel: hängt die App ihr Stylesheet
       beim Neuaufbau NACH unserem ein, gewinnt bei gleicher Spezifität und
       gleichem !important das spätere. Dieselbe Klasse mehrfach hebt die
       Spezifität, ohne den Selektor inhaltlich zu ändern — damit gewinnen wir
       unabhängig von der Reihenfolge. */
    var CSS = [
      /* ⚠️ NEUER ANSATZ 29.07. — den WRAPPER positionieren, nicht den Knopf.
         Am Geraet gemessen: eine Sonde mit `position: fixed !important` landet
         INNERHALB von `.activator-nudge` bei 616/364 statt 0/0, im Elternteil `div`
         dagegen sauber bei 0/0. Der Wrapper faengt fixierte Nachfahren also ab —
         und zwar nachweislich NICHT ueber `transform`, `translate`, `contain`,
         `will-change`, `filter`, `perspective`, `content-visibility` oder
         `container-type`: alle einzeln zurueckgesetzt, die Sonde blieb gefangen.
         Die Ursache ist damit unbekannt, das VERHALTEN aber sicher gemessen.
         Deshalb nicht laenger dagegen anarbeiten: der Wrapper wird selbst fixiert
         (sein Elternteil ist frei, dort funktioniert `fixed`), bekommt die Groesse
         des Knopfes, und der Knopf fuellt ihn mit `position: absolute; inset: 0`.
         ⚠️ Am 26.07. schon einmal versucht und gescheitert — damals aber an einem
         ANDEREN Grund: die App haengte den Knopf beim Neuaufbau um. Genau das faengt
         die Wache unten inzwischen ab. */
      '.activator-nudge.activator-nudge {',
      '  position: fixed !important;',
      '  right: var(--ne-float-x, 24px) !important;',
      '  bottom: calc(var(--ne-float-y, 24px) + var(--ne-float-size, 46px)',
      '               + var(--ne-float-gap, 12px)) !important;',
      '  top: auto !important; left: auto !important;',
      '  width: var(--ne-float-size, 46px) !important;',
      '  height: var(--ne-float-size, 46px) !important;',
      '  margin: 0 !important; padding: 0 !important;',
      /* Sperre bis --ne-float-gate — siehe :root oben.
         ⚠️ `opacity` allein genuegt nicht: ein unsichtbarer Knopf faengt weiter
         Klicks ab und laege dann UNSICHTBAR ueber dem CTA, was schlimmer waere
         als sichtbar. Deshalb `pointer-events` in derselben Schaltung.
         ⚠️ Bewusst KEIN `display: none` und kein `visibility: hidden`: die App
         misst beim Aufbau ihre eigene Knopfgroesse, und ein nicht gerendertes
         Element hat keine. Opazitaet laesst ihn gerendert. */
      '  opacity: var(--ne-float-opacity, 1) !important;',
      '  pointer-events: var(--ne-float-pe, auto) !important;',
      '  transition: opacity .28s ease !important;',
      '}',
      'button.activator.activator.activator {',
      /* Fuellt den fixierten Wrapper — keine eigene Positionierung mehr. */
      '  position: absolute !important;',
      '  inset: 0 !important;',
      '  width: var(--ne-float-size, 46px) !important;',
      '  height: var(--ne-float-size, 46px) !important;',
      '  min-width: 0 !important; min-height: 0 !important;',
      '  padding: 0 !important;',
      /* ⚠️ MUSS BLEIBEN. Der Wrapper unten steht auf `pointer-events: none`,
         damit sein leerer Kasten keine Klicks abfängt — und das vererbt auf
         den Knopf. Ohne diese Zeile ist der Chat-Knopf nicht mehr anklickbar
         (26.07 genau so passiert). Kinder holen sich das Zeigen mit `auto`
         zurück; das ist die einzige Ausnahme von der Vererbung. */
      '  pointer-events: auto !important;',
      '  display: grid !important; place-items: center !important;',
      '  border: 0 !important;',
      '  border-radius: 50% !important;',
      '  background-color: var(--ne-glass-bg, rgba(255, 255, 255, 0.08)) !important;',
      '  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0%,',
      '                                            rgba(255, 255, 255, 0.02) 100%) !important;',
      '  background-blend-mode: overlay;',
      '  -webkit-backdrop-filter: blur(var(--ne-glass-blur, 18px))',
      '                           saturate(var(--ne-glass-saturate, 140%)) !important;',
      '  backdrop-filter: blur(var(--ne-glass-blur, 18px))',
      '                   saturate(var(--ne-glass-saturate, 140%)) !important;',
      '  color: var(--ne-scheme-text, #fff) !important;',
      '  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35),',
      '              inset 0 -1px 0 rgba(0, 0, 0, 0.12),',
      '              0 8px 24px rgba(0, 0, 0, 0.30) !important;',
      '  transition: transform 0.25s ease, box-shadow 0.2s ease !important;',
      '}',
      'button.activator.activator.activator:hover { transform: translateY(-2px) !important; }',
      'button.activator.activator.activator:focus-visible {',
      '  outline: 2px solid var(--ne-scheme-accent, #6366f1) !important;',
      '  outline-offset: 3px !important;',
      '}',
      /* ⚠️ CONTAINING BLOCK NEUTRALISIEREN (29.07., vierter Anlauf am selben Knopf).
         Symptom: der Knopf stand nach einer Weile mitten im Bild statt unten rechts.
         Am Geraet gemessen war `position: fixed` gesetzt UND `bottom: 75.6px`
         korrekt gerechnet — der Knopf sass trotzdem 155px ueber der Kante, also
         genau um die 80px des Wrappers daneben. `position: fixed` wurde also nicht
         gegen das VIEWPORT aufgeloest, sondern gegen einen Vorfahren.
         Das passiert, sobald ein Vorfahre `transform`, `filter`, `backdrop-filter`,
         `perspective`, `will-change` oder `contain` traegt — die App legt so einen
         Wrapper beim Neuaufbau offenbar neu an.
         ⚠️ Deshalb half auch die Wache nicht: sie prueft `position === 'fixed'`,
         und die stimmte. Falsch war nicht die Eigenschaft, sondern ihr Bezugsrahmen.
         `*:has(button.activator)` trifft ausschliesslich die VORFAHREN des Knopfes —
         nicht den Knopf selbst (er braucht sein eigenes backdrop-filter) und nicht
         das Chatfenster (Geschwister, keine Vorfahren; seine Animation bleibt). */
      '*:has(button.activator), :host:has(button.activator) {',
      /* ⚠️ `translate`/`rotate`/`scale` sind EIGENE Eigenschaften, nicht Teil von
         `transform` — und ein Wert ungleich `none` erzeugt denselben Bezugsrahmen.
         Am Geraet gemessen stand auf `.activator-nudge` genau `translate: 0px`;
         `transform: none` allein lief deshalb ins Leere. Dieselbe Unterscheidung
         steht seit dem 26.07. im Pandectes-CSS als Warnung (Rule 539). */
      '  transform: none !important;',
      '  translate: none !important;',
      '  rotate: none !important;',
      '  scale: none !important;',
      '  filter: none !important;',
      '  backdrop-filter: none !important;',
      '  -webkit-backdrop-filter: none !important;',
      '  perspective: none !important;',
      '  will-change: auto !important;',
      '  contain: none !important;',
      '}',
      /* Der Wrapper darf nach dem Herausloesen des Knopfes keinen eigenen
         Kasten mehr aufspannen — sonst bleibt ein leerer Fleck stehen, der
         Klicks abfaengt. */
      '.activator-nudge {',
      '  background: none !important; box-shadow: none !important;',
      '  pointer-events: none !important;',
      '}',
      /* Gemessen: das Symbol steht auf 16 px und rgba(255,255,255,.7) — auf der
         Glasfläche zu blass und zu klein. Verhältnis wie beim Back-to-Top. */
      '.activator__icon, .activator__icon svg {',
      '  width: var(--ne-float-icon, 20px) !important;',
      '  height: var(--ne-float-icon, 20px) !important;',
      '  color: var(--ne-scheme-text, #fff) !important;',
      '  opacity: 1 !important;',
      '}',
      /* ⚠️ Klasse dreifach — mit einfacher Klasse überstimmt die App uns hier
         (gemessen 26.07: `display` blieb `block`, obwohl `grid` gesetzt war).
         Das Zentrieren ist das Entscheidende: das Symbol darin ist 16 px, der
         Kasten 20 px, und ohne Zentrierung sitzt es oben links — gemessen
         exakt −2,1 px auf beiden Achsen, also (20 − 16) / 2. */
      '.activator__icon.activator__icon.activator__icon {',
      '  display: grid !important; place-items: center !important;',
      '  translate: var(--ne-float-icon-dx, 0px) var(--ne-float-icon-dy, 0px) !important;',
      '}',
      /* ⚠️ DRITTE SHADOW-EBENE — über GRÖSSE nicht erreichbar, über SKALIERUNG
         schon. Gemessen 26.07: nach dem Öffnen steckt im Symbol nicht mehr
         direkt ein <svg>, sondern noch ein Custom-Element mit eigenem Root:

           button.activator > .activator__icon > shopify-chat-icon #sr > svg

         Ein Versuch mit `:host(shopify-chat-icon) { width: 100% }` samt
         passender svg-Regel im innersten Root blieb wirkungslos — das
         Stylesheet lag nachweislich dort, der Wirt mass trotzdem weiter 16 px.
         Statt eine vierte Runde daran zu drehen: `scale` wirkt auf ALLES
         darin, unabhängig von Shadow-Grenzen und ohne dass eine Regel drinnen
         greifen muss. Zentriert wird durch das Grid eine Ebene höher, der
         Ursprung der Skalierung ist von Haus aus die Mitte.

         1.25 ist 20/16 — Zielgröße geteilt durch die natürliche Größe des
         Symbols. Ändert sich --ne-float-icon, gehört diese Zahl nachgezogen;
         eine Division mit Einheiten lässt calc() nicht zu. */
      '.activator__icon shopify-chat-icon {',
      '  scale: var(--ne-float-icon-scale, 1.25) !important;',
      '}',
      /* ── Das Chatfenster selbst ────────────────────────────────────────
         ⚠️ NUR VON AUSSEN. Gemessen 26.07: das Fenster ist ein iframe auf
         `21rebel.store/agent/handoff`, das auf eine FREMDE HERKUNFT
         weiterleitet (`SecurityError` beim Zugriff auf contentWindow, trotz
         `allow-same-origin` im sandbox-Attribut). Sein Inhalt — und damit die
         Produktbilder — ist unerreichbar. Der ursprünglich gewünschte
         orange Glow HINTER den einzelnen Bildern ist deshalb nicht machbar;
         was bleibt, ist die Hülle.
         Das iframe selbst liegt im Agent-Root, in den wir ohnehin einhängen,
         also genügt ein normaler Selektor — `::part()` bräuchte es nur von
         ausserhalb des Roots.
         Die Inline-Größenangaben der App (`style="border:0;width:100%…"`)
         schlagen normale Regeln, deshalb !important. */
      /* Der Behaelter zieht den grossen Radius auf, nicht das iframe — er ist
         hier ohne Klassennamen zu treffen: `:has(> …)` beschreibt ihn ueber
         sein Kind, das wir kennen. Kein `overflow: hidden`, sonst wuerde der
         Glow des iframes darin abgeschnitten. */
      /* ⚠️ Gemessen 26.07 von innen nach aussen:
             iframe                      8px  (unsere Regel)
             div.panel__body             8px  (unsere :has-Regel)
             section.panel panel--right  36px ← DAS ist der sichtbare Radius
         Der Behaelter mit dem grossen Radius liegt also noch eine Ebene
         weiter aussen. `div:has(> iframe)` trifft nur den direkten Elternteil
         — die Section braucht ihre eigene Zeile.
         Kein `overflow: hidden`, sonst wuerde der Glow des iframes darin
         abgeschnitten; alle drei gerundet reicht. */
      /* ⚠️ Klasse dreifach, wie beim Knopf: die App setzt den Radius
         vermutlich ueber `.panel.panel--right` (0,2,0) und schlaegt damit ein
         einfaches `section.panel` (0,1,1) — !important auf beiden Seiten
         entscheidet dann die Spezifitaet, nicht die Reihenfolge. */
      'div:has(> iframe[part="iframe"]),',
      'section.panel.panel.panel {',
      '  border-radius: var(--ne-float-panel-radius, 8px) !important;',
      '}',
      'iframe[part="iframe"] {',
      '  border-radius: var(--ne-float-panel-radius, 8px) !important;',
      '  box-shadow:',
      '    0 0 0 1px var(--ne-glass-border, rgba(255, 255, 255, 0.12)),',
      '    0 18px 48px -12px rgba(0, 0, 0, 0.55),',
      '    0 0 32px -4px var(--ne-scheme-accent-glow, rgba(247, 147, 26, 0.35))',
      '    !important;',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  button.activator, button.activator:hover { transition: none !important; transform: none !important; }',
      '}'
    ].join('\n');

    /* ⚠️ JEDER Shadow-Root bekommt eine eigene Kopie — das ist der Kern.
       GEMESSEN am 26.07: beim Öffnen des Fensters lädt die App ihre
       Agent-Laufzeit nach und verlegt den Knopf dorthin:

         shopify-chat #shadow-root
           └─ shopify-agent-runtime #shadow-root
                └─ button.activator

       Ein Stylesheet wirkt NICHT über eine Shadow-Grenze hinweg. Unser <style>
       lag im äusseren Root, der Knopf sass im inneren — deshalb war der Knopf
       nach dem ersten Öffnen wieder werksmässig, und deshalb half auch keine
       höhere Spezifität. Eine Kopie pro Root ist der einzige Weg; teilen kann
       man Stylesheets zwischen Roots nur über adoptedStyleSheets, und das
       hiesse, in fremde Objekte zu greifen. */
    /* ⚠️ JEDER Root braucht einen EIGENEN Beobachter — `subtree: true`
       überschreitet keine Shadow-Grenzen (26.07 auf die harte Tour gelernt).
       Am Root von <shopify-chat> zu lauschen genügt also nicht: baut
       <shopify-agent-runtime> seinen eigenen Root neu auf, sieht der äussere
       Beobachter davon nichts, unsere Kopie dort verschwindet und der Knopf
       steht wieder in der Werksoptik da. Genau das ist mehrfach passiert. */
    var beobachtet = new WeakSet();

    function injizieren(wurzel) {
      if (!wurzel) return;
      if (!wurzel.querySelector('style[' + MARKE + ']')) {
        var el = document.createElement('style');
        el.setAttribute(MARKE, '');
        el.textContent = CSS;
        wurzel.appendChild(el);
      }
      if (!beobachtet.has(wurzel)) {
        beobachtet.add(wurzel);
        /* Feuert auch auf unser eigenes appendChild. Unschädlich: durchlaufen()
           erkennt vorhandene Kopien und tut dann nichts, die Schleife endet
           also nach einem Durchgang. */
        new MutationObserver(function () {
          durchlaufen(wurzel);
        }).observe(wurzel, { childList: true, subtree: true });
      }
    }

    function durchlaufen(wurzel) {
      injizieren(wurzel);
      wurzel.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) durchlaufen(el.shadowRoot);
      });
    }

    function anwenden() {
      var host = document.querySelector('shopify-chat');
      if (!host || !host.shadowRoot) return false;
      /* Das Beobachten erledigt injizieren() pro Root selbst — die
         verschachtelten Roots entstehen erst beim Öffnen des Fensters, also
         lange nach diesem ersten Durchlauf. */
      durchlaufen(host.shadowRoot);
      return true;
    }

    if (!anwenden()) {
      /* Das Element wird von der App-Einbettung nachgeladen, existiert beim
         ersten Lauf also meist noch nicht. Beobachten statt pollen — und nach
         30 s aufgeben, damit kein Beobachter für immer mitläuft, wenn die App
         gar nicht installiert ist. Den Dauerbetrieb übernimmt die Wache unten. */
      var beobachter = new MutationObserver(function () {
        if (anwenden()) beobachter.disconnect();
      });
      beobachter.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { beobachter.disconnect(); }, 30000);
    }

    /* ⚠️ DAUERWACHE (29.07). Ohne sie driftet der Chat-Knopf zurück in die
       Werksposition, sobald die Seite länger offen ist — vom User auf Zen und
       Chrome im privaten Fenster reproduziert.

       Zwei Fehler steckten in der Fassung davor. (1) Der Beobachter wurde NUR
       im `if (!anwenden())`-Zweig installiert — gelang die erste Injektion, gab
       es überhaupt keinen. (2) Auch dort wurde er nach 30 s abgeschaltet. Die
       Beobachter aus `injizieren()` hängen jeweils an IHREM Root; baut die App
       ihren Shadow-Inhalt neu auf (sie tut das beim Öffnen und Schließen des
       Fensters), sitzen sie auf abgelösten Knoten und feuern nie wieder.

       Bewusst ein Intervall statt eines dauerhaften `subtree: true`-Beobachters
       auf dem Dokument: so einer läuft bei JEDER DOM-Änderung mit, und genau so
       einen haben wir heute aus dem Menü-Block entfernt (Rule 533/534). Der
       Tick hier ist ein einziges `querySelector` im Shadow-Root und steigt
       sofort wieder aus, wenn das Stylesheet noch dranhängt — der Normalfall.
       Im Hintergrundtab passiert gar nichts. */
    function wache() {
      if (document.visibilityState !== 'visible') return;
      var host = document.querySelector('shopify-chat');
      if (!host || !host.shadowRoot) return;

      /* ⚠️ NICHT auf Vorhandensein pruefen, sondern auf WIRKUNG (29.07., zweiter
         Anlauf). Die erste Fassung stieg aus, sobald `style[MARKE]` noch im Root
         hing — der Knopf war da aber schon wieder verrutscht. Grund: die App haengt
         beim Neuaufbau ihr eigenes Stylesheet NACH unserem ein und gewinnt dann bei
         gleicher Spezifitaet, obwohl unseres unveraendert dasteht. Das Vorhandensein
         sagt also nichts ueber die Wirkung.
         Geprueft wird deshalb der einzige Wert, auf den es ankommt: steht der Knopf
         auf `position: fixed`? Wenn nicht, wird unser Stylesheet ENTFERNT und neu
         angehaengt — damit steht es wieder als letztes und gewinnt. */
      var btn = host.shadowRoot.querySelector('button.activator');
      var eigen = host.shadowRoot.querySelector('style[' + MARKE + ']');
      var wirkt = btn && getComputedStyle(btn).position === 'fixed';
      if (eigen && (wirkt || !btn)) return;
      if (eigen) eigen.remove();
      durchlaufen(host.shadowRoot);
    }

    /* ⚠️ Takt ALLEIN reicht nicht (29.07., dritter Anlauf). Der User hat den Knopf
       nach Bildschirm-Standby wieder verrutscht vorgefunden, obwohl er im laufenden
       Betrieb sass. Grund: Browser frieren `setInterval` in ausgeblendeten Seiten
       ein, und nach dem Aufwachen laeuft er nicht zwingend sofort wieder an — der
       Wächter oben steigt bei `visibilityState !== 'visible'` ohnehin aus. Genau in
       dieser Zeit baut die App ihren Shadow-Inhalt neu auf.
       Deshalb zusaetzlich an den ZUSTANDSWECHSEL haengen: `visibilitychange` deckt
       Standby und Tabwechsel ab, `pageshow` zusaetzlich die Rueckkehr aus dem
       bfcache (dort laeuft gar kein Skript weiter). Beide feuern selten und kosten
       nichts; die Pruefung selbst ist ein einziges querySelector. */
    setInterval(wache, 4000);
    document.addEventListener('visibilitychange', wache);
    addEventListener('pageshow', wache);
    addEventListener('focus', wache);

    /* ── Sperre: beide App-Knoepfe erst nach kurzem Scrollen (06.08.) ─────────
       Schwelle kommt aus `--ne-float-gate` (150px), damit sie an EINER Stelle
       steht und der Cookie-Knopf im Pandectes-CSS mit demselben Wert rechnet.

       ⚠️ Bewusst eine FESTE Zahl und nicht die Hero-Unterkante. Der erste
       Anlauf am 06.08. mass die erste Section und kam auf 754px bei 844px
       Sichthoehe — man musste fast einen ganzen Bildschirm scrollen, das las
       sich als Fehler statt als Zurueckhaltung. Und die Messung selbst war
       falsch: die erste Section in `main` ist auf Mobil 0px hoch, das ist der
       versteckte Hero-ZWILLING (Rule 581). Eine kurze feste Strecke tut, was
       sie soll, ohne von der Seitenstruktur abzuhaengen. */
    var tickt = false;

    function sichtbarkeit() {
      var grenze = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--ne-float-gate')) || 150;
      var zeigen = scrollY >= grenze;
      var s = document.documentElement.style;
      /* ⚠️ Nur schreiben, wenn sich etwas aendert. Ein `setProperty` auf `:root`
         entwertet den Stil des GANZEN Dokuments, weil jede Custom Property von
         jedem Element geerbt werden kann — das ist Rule 533, und sie gilt hier
         genauso wie im Theme. Bei jedem Scroll-Tick blind zu schreiben waere
         derselbe Fehler noch einmal. */
      var soll = zeigen ? '1' : '0';
      if (s.getPropertyValue('--ne-float-opacity') === soll) return;
      s.setProperty('--ne-float-opacity', soll);
      s.setProperty('--ne-float-pe', zeigen ? 'auto' : 'none');
    }

    function beiScroll() {
      if (tickt) return;
      tickt = true;
      requestAnimationFrame(function () { tickt = false; sichtbarkeit(); });
    }

    sichtbarkeit();
    addEventListener('scroll', beiScroll, { passive: true });
    /* Rueckkehr aus dem bfcache: die Seite kann mitten im Dokument aufwachen. */
    addEventListener('pageshow', sichtbarkeit);
  })();
  } catch(e) { console.error(e); }
})();

})();
